import { Step, StepLabel, Stepper } from '@material-ui/core';
import React from 'react';
import './style-fature-mais.css';

const Wizard = ({ steps, activeStep }) => {
  return (
    <Stepper activeStep={activeStep} alternativeLabel>
      {steps.map((step) => (
        <Step key={step.value}>
          {step.pularEtapa ? (
            <StepLabel className="pular-etapa" StepIconProps={{ active: false, completed: false }} disabled={true}>
              {step.label}
            </StepLabel>
          ) : (
            <StepLabel>{step.label}</StepLabel>
          )}
        </Step>
      ))}
    </Stepper>
  );
};

export default Wizard;
